import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import apiInstance from "../apiConfig/apiinstance";

const Category = ({ SubCategory, subCategoryError }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [category, setCategory] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState("");
  const categoryRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const fetchSubCategoryData = async (categoryQuery) => {
    if (!categoryQuery) return;
    setLoading(true);
    setError(null);

    try {
      const { data } = await apiInstance.get(
        `/api/cat/v1/child-categories/?slug=${categoryQuery}`
      );

      if (data.status === 200) {
        if (!data?.data?.length) {
          setError("No SubCategory found");
          setCategory([]);
        } else {
          setCategory(data.data);
        }
      }
    } catch (error) {
      setError(
        error?.response?.data?.message || "Error fetching subcategories"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const lastCategory = pathSegments[pathSegments.length - 1];

    if (SubCategory?.length > 0) {
      setCategory(SubCategory);
      setError(subCategoryError);
    } else {
      fetchSubCategoryData(lastCategory);
    }
  }, [location.pathname, SubCategory, subCategoryError]);

  useEffect(() => {
    updateScrollState();
  }, [category]);

  const updateScrollState = () => {
    if (categoryRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = categoryRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
    }
  };

  const handleCategoryClick = (item) => {
    setActive(item.name);

    // Get all segments after 'filter-product' for correct nesting
    const segments = location.pathname.split("/").filter(Boolean);
    const idx = segments.indexOf("filter-product");
    const currentCategories = idx !== -1 ? segments.slice(idx + 1) : [];
    // Add the new subcategory to the current path
    const updatedPath = `/filter-product/${[
      ...currentCategories,
      item.slug,
    ].join("/")}?view=apparel`;

    navigate(updatedPath);
  };

  const scrollLeft = () => {
    if (categoryRef.current) {
      categoryRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (categoryRef.current) {
      categoryRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <div className="category-container">
      {loading ? (
        <p>Loading...</p>
      ) : category.length > 0 ? (
        <>
          {canScrollLeft && (
            <p
              className="left pr-1 sm:pr-2 md:pr-4"
              onClick={() => {
                scrollLeft();
                setTimeout(updateScrollState, 300);
              }}
            >
              <IoChevronBack style={{ cursor: "pointer" }} />
            </p>
          )}
          <div
            className="category"
            ref={categoryRef}
            onScroll={updateScrollState}
          >
            {category.map((item) => (
              <p
                key={item.cat_id}
                onClick={() => handleCategoryClick(item)}
                className={`filter-btn font-size ${
                  active === item.name ? "active" : ""
                }`}
              >
                {item.name}
              </p>
            ))}
          </div>
          {canScrollRight && (
            <p
              className="right pl-1 sm:pl-2 md:pl-4"
              onClick={() => {
                scrollRight();
                setTimeout(updateScrollState, 300);
              }}
            >
              <IoChevronForward style={{ cursor: "pointer" }} />
            </p>
          )}
        </>
      ) : null}
    </div>
  );
};

export default Category;
